import { render, staticRenderFns } from "./DIVEMetadataFilterItem.vue?vue&type=template&id=1345d955&scoped=true"
import script from "./DIVEMetadataFilterItem.vue?vue&type=script&lang=ts"
export * from "./DIVEMetadataFilterItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1345d955",
  null
  
)

export default component.exports